import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

import useIsMobile from 'utils/useIsMobile';

import Submenu from './Submenu';

import { getServices } from './api/getServices';

import './sidebar.scss';
import './submenu.scss';

const Sidebar = () => {
  const [navList, setNavList] = useState([]);
  const { t } = useTranslation('global');
  const location = useLocation();
  const isMobile = useIsMobile();

  const { language } = i18n;

  const isLinkActive = path => {
    return location.pathname === path;
  };

  const generateClassName = path =>
    `sidebar-link non-drop ${isLinkActive(path) && 'active'}`;

  const handleGetServices = useCallback(async () => {
    const reqServices = await getServices();
    if (reqServices.data) {
      if (Array.isArray(reqServices.data)) {
        setNavList(reqServices.data.sort((a, b) => a.id - b.id));
      }
    }
  }, []);

  useEffect(() => {
    if (language) {
      handleGetServices();
    }
  }, [language, handleGetServices]);

  return isMobile ? (
    <div className="sidebar-mobile-content">
      <div className="sidebar-mobile-wrap">
        <Link to="/" className={generateClassName('/')}>
          <span className="sidebar-submenu-label">
            👋 {t('sidebar.Introduction')}
          </span>
        </Link>

        {navList.map(item => {
          return (
            <Submenu
              path="/services/details"
              item={item}
              key={`${item.id}-${item.name}`}
            />
          );
        })}
      </div>
    </div>
  ) : (
    <div className="sidebar">
      <div className="sidebar-wrap">
        <Link to="/" className={generateClassName('/')}>
          <span className="sidebar-submenu-label">
            👋 {t('sidebar.Introduction')}
          </span>
        </Link>

        {navList.map(item => {
          return (
            <Submenu
              path="/services/details"
              item={item}
              key={`${item.id}-${item.name}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
